import React from 'react';
import { useRealtimeAuth } from '@/hooks/useRealtimeAuth';
import { RealtimeAuthContext } from './useRealtimeAuthContext';

interface RealtimeAuthProviderProps {
  children: React.ReactNode;
}

/**
 * Provides a single shared `isRealtimeReady` boolean to the entire app.
 * Eliminates N redundant `supabase.auth.getSession()` calls that previously
 * occurred inside every `useRealtimeSubscription` instance.
 */
export function RealtimeAuthProvider({ children }: RealtimeAuthProviderProps) {
  const isRealtimeReady = useRealtimeAuth();
  return (
    <RealtimeAuthContext.Provider value={isRealtimeReady}>
      {children}
    </RealtimeAuthContext.Provider>
  );
}
